export const CARD_BG_COLORS = {
  background: "bg-background",
  surface: "bg-surface",
  surface2: "bg-surface-2",
  surface3: "bg-surface-3",
  surfaceInverse: "bg-surface-inverse",
} as const

export type CardBgColorsType = keyof typeof CARD_BG_COLORS

export const CARD_AS = {
  div: "div",
  section: "section",
  form: "form",
} as const

export type CardAsType = keyof typeof CARD_AS

export const CARD_CONTENT_DIRECTION = {
  row: "flex-row",
  column: "flex-col",
} as const

export type ContentDirectionType = keyof typeof CARD_CONTENT_DIRECTION

export const CARD_PADDING = {
  xl: "padding-xl",
  l: "padding-l",
  m: "padding-m",
  s: "padding-s",
} as const

export type CardPaddingType = keyof typeof CARD_PADDING

export const CARD_TEXT_ALIGN = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
} as const
export type CardTextAlignType = keyof typeof CARD_TEXT_ALIGN

export const CARD_BORDER = {
  primary: "border-primary",
  accent: "border-accent",
  gray: "border-gray",
} as const

export type CardBorderType = keyof typeof CARD_BORDER

export const CARD_CONTENT_ALIGN = {
  center: "align-center",
  start: "align-start",
  end: "align-end",
  stretch: "align-stretch",
} as const

export type CardContentAlignType = keyof typeof CARD_CONTENT_ALIGN

export const CARD_JUSTIFY_CONTENT = {
  center: "justify-center",
  start: "justify-start",
  end: "justify-end",
  between: "justify-space-between",
  around: "justify-space-around",
  evenly: "justify-space-evenly",
} as const

export type CardJustifyContentType = keyof typeof CARD_JUSTIFY_CONTENT

export const CARD_GAP = {
  "2xs": "gap-2xs",
  xs: "gap-xs",
  s: "gap-s",
  m: "gap-m",
  l: "gap-l",
  xl: "gap-xl",
  "2xl": "gap-2xl",
} as const

export type CardGapType = keyof typeof CARD_GAP
